import React, { useState, useEffect } from 'react';
import {
    Tabs,
    Table,
    Modal
} from 'antd';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import CssBaseline from '@material-ui/core/CssBaseline';

import NavMenu from 'components/NavMenu';
import TextEvents from 'app/components/TextEvents';
import TableContainer from 'app/containers/TableContainer';
import EvaluationForm from 'app/components/EvaluationForm';
import CreateEvaluation from 'app/components/CreateEvaluation';
import EditEvaluation from 'app/components/EditEvaluation';
import EditQuestionContainer from 'app/containers/EditQuestionContainer';
import { useDispatch, useSelector } from 'react-redux';

import { clearTest } from 'app/actions/TestActions';
import { useStyles, styles } from './EvaluationsScreenStyles';


export default function EvaluationsScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth);

    const { TabPane } = Tabs;
    const [filter, setFilter] = useState([]);
    const [activeKey, setTabBar] = useState('1');
    const tabs = { '1': 'Bandeja de evaluaciones', '2': 'Crear evaluación', '3': `${siteId === 'HUB' ? 'Editar' : 'Visualizar'} evaluación` }
    const [idTest, setIdTest] = useState();
    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros` });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    useEffect(() => {
        return () => {
            dispatch(clearTest());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });


    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isAdmin={true} header='Evaluaciones' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Evaluación
                        </Link>
                        <TextEvents
                            text={tabs[activeKey]}
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Tabs tabBarStyle={{ margin: 0 }} type='card' activeKey={activeKey} defaultActiveKey='2' className={classes.tabContainer} onChange={tab => setTabBar(tab)}>
                    <TabPane tab='Buscar' key='1'>
                        <Paper className={classes.paper} key='1'>
                            <EvaluationForm filter={filter} setFilter={setFilter} setTab={setTabBar} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} />
                            <div style={styles.baseVerticalMargin}>
                                <TableContainer classes={classes} setTab={setTabBar} setIdTest={setIdTest} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData}>
                                    {(params) => {
                                        return (
                                            <div>
                                                <Table
                                                    useFixedHeader={true}
                                                    loading={params.isLoading}
                                                    rowKey={item => String(item.idTest)}
                                                    columns={params.cols}
                                                    dataSource={params.evaluations}
                                                    onChange={params.handleTableChange}
                                                    pagination={pagination}
                                                    scroll={{ x: "min-content", y: (height - 395) }}
                                                    size={"small"}
                                                />
                                            </div>
                                        )
                                    }}
                                </TableContainer>
                            </div>
                        </Paper>
                    </TabPane>
                    {activeKey === '2' ?
                        <TabPane tab='Nuevo' key='2' className={classes.tab}>
                            <Paper className={classes.paper} key='2'>
                                <CreateEvaluation setTab={setTabBar} formData={formData} />
                            </Paper>
                        </TabPane> : ''}
                    {activeKey === '3' ?
                        <TabPane tab={siteId === 'HUB' ? 'Editar' : 'Visualizar'} key='3' className={classes.tab}>
                            <Paper className={classes.paper} key='2'>
                                <TableContainer idTest={idTest} >
                                    {(params) => {
                                        const filterParam = params.evaluations.find(function (element) {
                                            return element.idTest === idTest;
                                        });
                                        return (
                                            <div>
                                                <EditQuestionContainer filterData={filterParam}>
                                                    {(editParams) => {
                                                        return (
                                                            <div>
                                                                <EditEvaluation setTab={setTabBar} idTest={idTest} editParam={filterParam} questions={editParams.testQuestions} formData={formData} />
                                                            </div>
                                                        )
                                                    }
                                                    }
                                                </EditQuestionContainer>
                                            </div>
                                        )
                                    }}
                                </TableContainer>
                            </Paper>
                        </TabPane> : ''}
                </Tabs>
            </div>
        </div>
    )
}